module.exports = __webpack_public_path__ + "img/tubiao-09.9958ad21.png";